import e from "@dialpad/dialtone-icons/illustrations.js";
//#region components/illustration/illustration_constants.js
var t = e, n = { ILLUSTRATION_NAMES: t };
//#endregion
export { t as ILLUSTRATION_NAMES, n as default };

//# sourceMappingURL=illustration-constants.js.map